import { AbstractJsonApiService } from './abstract-json-api.service';
import { LoggedInUser } from '@ipensii/shared/domain-shared';

export class LoggedInContextService extends AbstractJsonApiService<LoggedInUser> {
  constructor() {
    super('current-user');
  }
}
